import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextFormatterService {

  /**
   * Converts newline characters (\n) to HTML break tags (<br>)
   * @param text - The text to format
   * @returns Formatted text with <br> tags or empty string if input is null/undefined
   */
  formatNewlinesToHtml(text: string | null | undefined): string {
    return text ? text.replace(/\n/g, '<br>') : '';
  }
}
